import type { User } from '../contexts/UserContext';

/** Dev/pilot person slugs — not backed by companies.kryspace_slug; always read from disk. */
export const PERSONAL_MODEL_PILOT_SLUGS = new Set(['orlin_wetzker']);

/** Dev/pilot mapping until roster exposes personal_model slugs. */
const PERSONAL_SLUG_BY_USERNAME: Record<string, string> = {
  orlin: 'orlin_wetzker',
  owetz: 'orlin_wetzker',
  orlin_wetzker: 'orlin_wetzker',
};

export function isPersonalModelPilotSlug(slug: string | null | undefined): boolean {
  const normalized = (slug || '').trim().toLowerCase();
  return normalized.length > 0 && PERSONAL_MODEL_PILOT_SLUGS.has(normalized);
}

export function resolvePersonalModelSlugFromUsername(raw?: string | null): string | null {
  const username = (raw || '').trim().toLowerCase();
  if (!username) return null;
  if (PERSONAL_SLUG_BY_USERNAME[username]) {
    return PERSONAL_SLUG_BY_USERNAME[username];
  }
  for (const [key, slug] of Object.entries(PERSONAL_SLUG_BY_USERNAME)) {
    if (username.includes(key)) return slug;
  }
  return null;
}

export function resolvePersonalModelSlug(user: User | null | undefined): string | null {
  if (!user) return null;
  return resolvePersonalModelSlugFromUsername(user.username);
}

export function personalHubControlBridgePath(slug: string): string {
  return `/render/${encodeURIComponent(slug)}/control-bridge`;
}
